module.exports = __webpack_public_path__ + "static/img/reject.16f3336b.svg";